import { Link } from 'react-router-dom';
import AseLogo from '../assets/ase-logo.png';

const NotFound = () => {
  return (
    <div className="flex flex-col items-center justify-center flex-grow min-h-screen">
      <img src={AseLogo} alt="ASE Group" className='h-[50px] mb-6' />

      <h1 className='text-[50px] font-bold mb-4'>Not Found</h1>
      <Link to="/" className="text-white font-semibold text-[36px] bg-ase-blue rounded-md px-8">Back to Dashboard</Link>
    </div>
  )
}

export default NotFound;
